import { initializeEditor, initializePage } from "@/content-hub/store/effect";

import { takeLatest } from "./typed-saga-effects";

export default function* rootSaga() {
  yield* takeLatest("[page editor] initialize editor", initializeEditor);
  yield* takeLatest("[content page] initialize page", initializePage);
}
